<template>
    <Layout>
      <template v-if="this.$route.name == 'add-campaigns'">
        <PageHeader :title="title1" :items="items"></PageHeader>
      </template>
      <template v-else>
        <PageHeader :title="title2" :items="items"></PageHeader>
      </template>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body" id="medinext">
              <b-form enctype="multipart/form-data" ref="promotion">
                <div class="row">
                    <b-form-group class="col-lg-6 col-md-6 col-sm-12">
                        <label for="campaign_title">Campaign Title <span style="color: red">*</span></label>
                        <b-form-input
                        type="text"
                        id="campaign_title"
                        placeholder="Enter Campaign Title"
                        v-model="form.title"
                        :class="{
                          'is-invalid': submitted && $v.form.title.$invalid,
                        }"
                        ></b-form-input>
                        <div v-if="submitted && !$v.form.title.required" class="invalid-feedback">
                            Campaign Title is required.
                        </div>
                    </b-form-group>
                    <b-form-group class="col-lg-6 col-md-6 col-sm-12">
                        <label for="campaign_slug">Campaign Slug <span style="color: red">*</span></label>
                        <b-form-input
                        type="text"
                        id="campaign_slug"
                        placeholder="Enter Ad Title"
                        v-model="form.slug"
                        :class="{
                          'is-invalid': submitted && $v.form.slug.$invalid,
                        }"
                        ></b-form-input>
                        <div v-if="submitted && !$v.form.slug.required" class="invalid-feedback">
                            Campaign Slug is required.
                        </div>
                    </b-form-group>
                  <b-form-group class="col-lg-6 col-md-6 col-sm-12">
                    <label for="logo">Campaign Icon</label>
                    <b-form-file
                      accept="image/*"
                      placeholder="Choose a file or drop it here..."
                      id="camp_icon"
                      @change="readFile($event, 'camp_icon')"
                      ref="camp_icon"
                    >
                    </b-form-file>
                    <template
                      v-if="$route.name == 'edit-campaigns' && edit.camp_img_url"
                    >
                      <img
                        :src="edit.camp_img_url"
                        width="128px"
                        height="128px"
                        style="object-fit: contain; margin-top: 5px"
                      />
                    </template>
                    <template v-if="camp_img_url">
                      <img
                        :src="camp_img_url"
                        width="128px"
                        height="128px"
                        ref="camp_img_url"
                        style="object-fit: contain; margin-top: 5px"
                      />
                    </template>
                  </b-form-group>
                </div>
                <b-button
                  type="submit"
                  variant="primary"
                  class="mr-2"
                  @click.prevent="submitData"
                >
                  <span v-if="this.$route.name == 'add-campaigns'"
                    >Save Data</span
                  >
                  <span v-else>Update Data</span>
                </b-button>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  </template>
  
  <script>
  import Layout from "../../../layouts/main";
  import PageHeader from "@/components/page-header";
  import MixinRequest from "../../../../mixins/request";
  import mrappcampaignMixin from "../../../../mixins/ModuleJs/campaigns";
  import { required } from "vuelidate/lib/validators";
  
  export default {
    data() {
      return {
        submitted: false,
        title1: "Add Campaigns",
        title2: "Edit Campaigns",
        items: [
          {
            text: "List",
            href: "/field-rep-app/campaigns",
          },
          {
            text: "Data",
          },
        ],
      };
    },
    mixins: [MixinRequest, mrappcampaignMixin],
    components: {
      Layout,
      PageHeader
    },
    validations: {
      form: {
        title: { required },
        slug: { required },
        // camp_icon: { required }
      },
    },
  };
  </script>
  